import React from 'react';
import { View, StyleSheet, Pressable } from 'react-native';
import { IconButton, Badge } from 'react-native-paper';
import { useNotifications } from '../../providers/NotificationProvider';

interface NotificationBellProps {
    onPress: () => void;
    active: boolean;
}

const NotificationBell: React.FC<NotificationBellProps> = ({ onPress, active }) => {
    const { unreadCount } = useNotifications();

    return (
        <Pressable 
            onPress={onPress}
            style={({ pressed }) => [
                styles.container,
                active && styles.activeContainer,
                pressed && styles.pressed
            ]}
        >
            <IconButton
                icon={unreadCount > 0 ? "bell-ring-outline" : "bell-outline"}
                iconColor="#FFFFFF"
                size={22}
                style={styles.iconButton}
            />
            {unreadCount > 0 && (
                <Badge
                    size={16}
                    style={styles.badge}
                >
                    {unreadCount}
                </Badge>
            )}
        </Pressable>
    );
};

const styles = StyleSheet.create({
    container: {
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        marginRight: 4,
    },
    activeContainer: {
        backgroundColor: 'rgba(255, 255, 255, 0.25)',
    },
    pressed: {
        opacity: 0.75,
        transform: [{ scale: 0.96 }],
    },
    iconButton: {
        margin: 0,
    },
    badge: {
        position: 'absolute',
        top: 2,
        right: 2,
        backgroundColor: '#BA1A1A',
        color: '#FFFFFF',
        fontWeight: '700',
        borderWidth: 1.5,
        borderColor: '#4BB75F', // matches topbar bg color
    }
});

export default NotificationBell;
